<template>
  <div class="h5Bottom">
    <div :class="activeTab == 1 ? 'activeTab' : ''" @click="toUrl()">首页</div>
    <div :class="activeTab == 2 ? 'activeTab' : ''" @click="toUrl(1)">个人中心</div>
  </div>
</template>

<script>

export default {
  data() {
    return {
      activeTab: -1,
    };
  },

  props: ['activeIndex'],

  methods: {
    toUrl(type) {
      if (!this.$cookie.get('token') && type) return this.$router.push({name: 'login', query: this.$route.query, params: {backOtherPage: 'personalCenter'}})
      this.$router.push({name: !type ? 'home' : 'personalCenter', query: this.$route.query})
    }
  },

  created() {
    this.activeTab = this.activeIndex || -1
  },

  computed: {
  
  }
}
</script>

<style scoped lang="scss">
.h5Bottom{
  position: fixed;
  bottom: 0;
  width: calc(100vw - 4.52rem);
  height: 1.3rem;
  font-size: 0.39rem;
  background: #FFFDFA;
  border-top: 0.01rem solid #E4CEAE;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.26rem 2.26rem;
  div{
    padding-top: 0.57rem;
    position: relative;
    &:before{
      height: 0.55rem;
      width: 0.55rem;
      content: '';
      display: inline-block;
      position: absolute;
      top: 0;
      left: 50%;
      margin-left: -0.27rem;
    }
    &:nth-child(1){ //首页
      &:before{
        background: url('../../assets/ticket/icon_home.png') 0 0/ contain no-repeat;
      }
    }
    &:nth-child(2){ //首页
      &:before{
        background: url('../../assets/ticket/icon_user.png') 0 0/ contain no-repeat;
      }
    }
  }
  .activeTab{
    &:nth-child(1){ //首页
      &:before{
        background: unset;
        -webkit-mask: url('~@/assets/ticket/home_icon_active.svg') 0 0/100% 100% no-repeat;
        mask: url('~@/assets/ticket/home_icon_active.svg') 0 0/100% 100% no-repeat;
      }
    }
    &:nth-child(2){ //首页
      &:before{
        background: unset;
        -webkit-mask: url('~@/assets/ticket/user_icon_active.svg') 0 0/100% 100% no-repeat;
        mask: url('~@/assets/ticket/user_icon_active.svg') 0 0/100% 100% no-repeat;
      }
    }
  }
}
</style>
